<template>
  <div>
    <div class="privacy-body" v-if="loaded">
      <h1>{{ pageTitle }}</h1>
      <span>{{ formatDate(updatedAt) }}</span>
      <div class="doc-contents">
        <div class="nav-holder">
          <ol>
            <li v-for="heading in headings" :key="getHeadingId(heading)">
              <a :href="getHeadingId(heading)">
                {{ getHeadingTitle(heading) }}
              </a>
            </li>
          </ol>
        </div>

        <div class="content-holder">
          <editor-content :editor="editor" />
        </div>
      </div>
    </div>

    <div class="loading" v-else></div>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils';
import { Editor, EditorContent } from 'tiptap';
import { getViewDocumentDetails } from '@/api/requests';
import TocHeading from '@/components/content_editor/TocHeading.js';
import {
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Strike,
  Underline,
} from 'tiptap-extensions';

export default {
  name: "ContentOutput",

  props: {
    type: {
      type: String,
      default: 'terms'
    }
  },

  components: {
    EditorContent,
  },

  data() {
    return {
      contents: '',
      editor: null,
      headings: [],
      updatedAt: '',
      loaded: false,
    }
  },

  mounted() {
    getViewDocumentDetails(this.type).then(response => {
      let data = response.data;
      let jsonData = JSON.parse(data.data);
      let stringBody = jsonData[0].body;
      this.updatedAt = jsonData[0].updated_at;
      this.contents = JSON.parse(stringBody);
      this.editor = new Editor({
        editable: false,
        content: this.contents,
        extensions: [
          new BulletList(),
          new TocHeading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
        ],
      });
      this.getPageOptions();
      this.loaded = true;
    }).catch(() => {
      // TODO errors
    });
  },

  methods: {
    getHeadingTitle(heading) {
      return heading['content'][0]['text'];
    },

    getHeadingId(heading) {
      return '#' + heading['attrs']['id'];
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    getPageOptions() {
      this.contents['content'].forEach(content => {
        if ((content.type === 'heading') && (content.attrs.level === 2)) {
          this.headings.push(content);
        }
      });
    },
  },

  computed: {
    pageTitle() {
      if (this.type === 'privacy') {
        return 'PRIVACY POLICY';
      } else {
        return 'TERMS OF SERVICE';
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/variables";

.loading {
  height: 100vh;
}

.privacy-body {
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1022px;
  margin: auto;

  h1 {
    text-transform: uppercase;
  }

  span {
    color: $sec2;
  }

  .doc-contents {
    display: flex;
    padding-top: $spacing-large;
  }

  .nav-holder {
    display: block;
    position: sticky; top:0;
    left: 0;
    width: 30%;
    align-self: flex-start;
    padding-right: $spacing-base;

    ol {
      color: $blue;
      font-size: 14px;
      padding: 0;
      padding-left: 0px;
      list-style: none;

      li {
        padding-bottom: $spacing-base;
      }

      a {
        color: $blue;
        text-decoration: none;
      }
    }
  }

  .content-holder {
    width: 70%;
    padding-bottom: $spacing-large*2;
  }

  h1 {
    margin: 0;
    text-align: left;
    font-size: 48px;
    color: $sec0;
  }

  h2:not(:first-child):before{
    height: 80px;
    content: "";
    background-image: url(~@/assets/landing-page/divider.webp);
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    display: inline-block;
  }

  h2 {
    margin: 0;
    text-align: left;
    font-weight: 500;
    font-size: 36px;
    color: $sec2;
    text-transform: uppercase;
    padding-bottom: 16px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: $sec2;
  }

  p {
    font-size: 16px;
    color: $sec2;
    margin-top: 0;
  }

  .last-updated {
    text-align: center;
    margin: 0;
  }

  .divider {
    background-image: url(~@/assets/landing-page/divider.webp);
    max-width: 1200px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 40px;
  }
  
  ul {
    color: $sec2;
  }

  ol {
    color: $sec2;
  }

  .links {
    list-style: none;
    padding: 0;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;

    li {
      margin-bottom: $spacing-small;

      a {
        color: $blue;
        text-decoration: none;
      }
    }
  }
}

@media all and (max-width: 650px) {
  .privacy-body {
    .nav-holder {
      width: 100%;
      position: relative;
    }

    .doc-contents {
      display: block;
    }

    h1 {
      text-align: center;
      font-size: 36px;
    }

    span {
      text-align: center;
      display: block;
    }

    .content-holder {
      width: 100%;
    }
  }
}
</style>